import Vue from 'vue'
import Router from 'vue-router'
// import Main from '@/components/main'
import Maintest from '@/components/main2'
//import Index from '@/components/index'
//import AsideTree from '@/components/aside_menu'
import home from '@/components/home'
import home2 from '@/components/home2'
import Test from '@/components/common/Test'
//import Test2 from '@/components/common/Test2'
import SearchMain from '@/components/search_engine/search_main'
import LocalSearch from '@/components/search_engine/local/search_local_main'
// import Search from '@/components/common/common_engine/search_main'
import Search from '@/components/common/common_engine/search_engine_index'
import USearch from '@/components/common/common_engine/user_search'
import JDSearch from '@/components/search_jd/jd_search'
import CasesSearch from '@/components/search_cases/cases_search'
import Tax_Chat from '@/components/tax_chat/chat'
import TaxCasesSearch from '@/components/tax_cases/tax_cases_search.vue'
import TaxExpertSearch from '@/components/tax_expert/tax_expert_search.vue'
import TaxFormSearch from '@/components/search_form/search_tax_form.vue'
import SmartCloud from '@/components/smart_cloud/cloud_main'
import CloudSearch from '@/components/smart_cloud/content_mainV2'
import MyAssistant from '@/components/my_assistant/assistant_main'
import AssistantContent from '@/components/my_assistant/content_main'
import MyIdentical from '@/components/identical_engine/identical_main'
import MyIdenticalContent from '@/components/identical_engine/identical_content'
import UserManual from '@/components/user_manual/manual_main'
import RiskDetection from '@/components/tax_risk_detection/risk_detection'
import UserVideo from '@/components/user_video/video_main'
import UserStore from '@/components/user_store/'
import UserPakage from '@/components/user_store/product_package'
import VipCenter from '@/components/user_store/vipcenter'
import FileMatch from '@/components/common/match/tax_incentives'

//import store from '../store'

Vue.use(Router)

const router = new Router({
    mode: "history",
    // base:'v2',
    routes: [{
            path: '/',
            name: 'Main',
            // component: Maintest,
            redirect: '/main' //'/main',
        },
        {
            path: "/fxjc",
            name:'fxjc',
            component: () => import("@/components/home/fxjc.vue"),
        },
        {
            path: "/bgyl",
            name:'bgyl',
            component: () => import("@/components/home/bgyl.vue"),
        },
        {
            path: '/main', //'/main',
            name: 'Main1',
            component: Maintest,
            redirect: '/localsearch', //'/main/searchengine',
            children: [
                // {
                //   path: '/searchengine',//'/main/searchengine',
                //   name: 'searchengine',
                //   component: SearchMain,
                //   redirect: '/search',//'/main/searchengine/search',
                //   children: [{
                //     path: '/search',//'/main/searchengine/search',
                //     name: 'search',
                //     component: Search,
                //     meta: {
                //       requireLogin: false,
                //     }
                //   }]
                // },
                // {
                //   path: '/test',
                //   name: 'Test',
                //   component: Test
                // },
                {
                  path: '/matchfile',
                  name: 'matchfile',
                  component: FileMatch
                },
                {
                    path: '/local',
                    name: 'localsearch',
                    component: SearchMain,
                    redirect: '/localindex',
                    children: [{
                        path: '/localsearch',
                        name: 'localindex',
                        component: LocalSearch
                    }]
                }
            ]
        },
        {
            path: '/main', //'/main',
            name: 'Main3',
            component: Maintest,
            children: [{
                path: '/jdsearch',
                name: 'jdsearch',
                component: JDSearch,
            }]
        },
        {
            path: '/main', //'/main',
            name: 'Main4',
            component: Maintest,
            children: [{
                path: '/casessearch',
                name: 'casessearch',
                component: CasesSearch,
            }]
        },
        {
            path: '/main', //'/main',
            name: 'Main4',
            component: Maintest,
            children: [{
                path: '/taxchat',
                name: 'taxchat',
                component: Tax_Chat,
            }]
        },
        {
            path: '/main', //'/main',
            name: 'Main5',
            component: Maintest,
            children: [{
                path: '/taxsearch',
                name: 'taxsearch',
                component: TaxCasesSearch,
            }]
        },
        {
            path: '/main', //'/main',
            name: 'Main6',
            component: Maintest,
            children: [{
                path: '/taxformsearch',
                name: 'taxformsearch',
                component: TaxFormSearch,
            }]
        },
        {
            path: '/main',
            name: 'Main7',
            component: Maintest,
            children: [{
                path: '/expertsearch',
                name: 'expertsearch',
                component: TaxExpertSearch,
            }]
        },
        {
            path: '/home',
            name: 'home',
            component: home2,

        },
        {
            path: '/reg',
            name: 'home',
            component: home2,

        },
        {
            path: '/bindwx',
            name: 'home',
            component: home2,

        },
        {
            path: '/main',
            name: 'Main2',
            component: Maintest,
            children: [
                //test
                {
                    path: '/cloud', //'/main/cloud',
                    name: 'smartCloud',
                    component: SmartCloud,
                    meta: {
                        requireLogin: true,
                    },
                    redirect: '/mycloud', //'/main/cloud/mycloud',
                    children: [{
                        path: '/mycloud', //'/main/cloud/mycloud',
                        name: 'mycloud',
                        component: CloudSearch,
                        meta: {
                            requireLogin: true,
                        },
                        // children: [{
                        //   path: '/main/cloud/mycloud/workbook',
                        //   name: 'myworkbook',
                        //   component: CloudSearch
                        // }]
                    }]
                },
                {
                    path: '/assistant', //'/main/assistant',
                    name: 'myassistant',
                    component: MyAssistant,
                    meta: {
                        requireLogin: true,
                    },
                    redirect: '/myassistant', //'/main/assistant/myassistant',
                    children: [{
                        path: '/myassistant', //'/main/assistant/myassistant',
                        name: 'cloudmsg',
                        component: AssistantContent,
                        meta: {
                            requireLogin: true,
                        },
                        // children: [{
                        //   path: '/main/cloud/mycloud/search',
                        //   name: 'mycloudsearch',
                        //   component: CloudSearch
                        // }]
                    }]
                },
                {
                    path: '/main/identical',
                    name: 'myidentical',
                    component: MyIdentical,
                    redirect: '/main/identical/myidentical',
                    children: [{
                        path: '/main/identical/myidentical',
                        name: 'identicalContent',
                        component: MyIdenticalContent,
                        // children: [{
                        //   path: '/main/cloud/mycloud/search',
                        //   name: 'mycloudsearch',
                        //   component: CloudSearch
                        // }]
                    }]
                },
                {
                    path: '/usersearch', //'/main/assistant',
                    name: 'usersearch',
                    component: USearch,
                    meta: {
                        requireLogin: false,
                    },
                },
                {
                    path: '/userstorev2', //'/main/assistant',
                    name: 'userstore',
                    component: UserPakage,
                    meta: {
                        requireLogin: true,
                    },
                },
                {
                    path: '/vipcenter', //'/main/assistant',
                    name: 'vipcenter',
                    component: VipCenter,
                    meta: {
                        requireLogin: true,
                    },
                },
                {
                    path: '/usermanual', //'/main/assistant',
                    name: 'usermanual',
                    component: UserManual,
                    meta: {
                        requireLogin: false,
                    },
                },
                {
                    path: '/riskdetection', //'/main/assistant',
                    name: 'riskdetection',
                    component: RiskDetection,
                    meta: {
                        requireLogin: false,
                    },
                },
                {
                    path: '/uservideo', //'/main/assistant',
                    name: 'uservideo',
                    component: UserVideo,
                    meta: {
                        requireLogin: false,
                    },
                }

            ]
        },
        {
            name: '404',
            path: '/404',
            component: () => import('@/components/common/notFound.vue')
        },
        {
            path: '*',
            name: 'N',
            redirect: '/' //匹配空
        },
    ]
})



// router.beforeEach(function(to, from, next) {
//   if (to.meta !== undefined && to.meta.requireLogin) {
//     console.log("smartCloud")
//   }else{
//     next()
//   }

// })


// router.beforeEach(function(to, from, next) {

//   if (from.path === '/main/cloud/mycloud') {
//     // console.log(store.state.user.workbook.isContentChanged)
//     if (store.state.user.workbook.isContentChanged) {
//       //提示
//       // const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
//       // if (answer) {
//       //   next()
//       // } else {
//       //   next(false)
//       // }
//     } else {
//       next()
//     }
//   } else {
//     next()

//   }
// })


// router.afterEach((transition) => {
//   // iView.LoadingBar.finish()
// })


export default router